import styled, { keyframes } from "styled-components";
import { AiOutlineClose } from 'react-icons/ai';

const slideUp = keyframes`
  from{
    opacity: 0;
    transform: translateY(-50px);
  }to{
    opacity: 1;
    transform: translateY(0);
  }
  
`
interface IModalContainerProps {
  width?: string,
  height?: string
}
export const ModalContainer = styled.div<IModalContainerProps>`
  width: 100%;
  ${props => props.width && `width: ${props.width}`};
  animation: ${slideUp} .7s forwards;
  background: ${props => props.theme.colors.white};
  display: flex;
  overflow-y: auto;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
   height: fit-content;
  max-height: 90%;
   ${props => props.height && `height: ${props.height}`};

   @media(max-width: 800px) {   
    max-height: 100%;
  }
`

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100dvh;
  background: rgba(0,0,0,.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Header = styled.div`
  width: 100%;
  padding: 10px;  
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px;
`

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const CloseIcon = styled(AiOutlineClose)`
  align-self: flex-end;
  :hover{
    cursor: pointer;
  }
`